import * as Yup from 'yup';
import { validateCidrs } from '../../../utils/cidrHelpers';

export const getErrorMessage = (error, cidr) => {
  if (error && error.response && error.response.data) {
    if (typeof error.response.data.detail === 'string') {
      return `${cidr}: ${error.response.data.detail}`;
    } else if (error.response.data.detail.cidr) {
      return `${cidr}: ${error.response.data.detail.cidr[0]}`;
    } else {
      return `${cidr}: ${JSON.stringify(error.response.data.detail)}`;
    }
  } else {
    const errorDiv = () => {
      return (
        <div>
          An error occurred, please try again. If this error persists, submit a
          ticket via the "Support" tab.
        </div>
      );
    };
    return errorDiv();
  }
};

export const formValidationSchema = Yup.object().shape({
  cidrs: Yup.array().test(
    'isCidrValid',
    'Invalid subnet mask.',
    function (value) {
      const { path, createError } = this;
      const result = validateCidrs(value)
        ? true
        : createError({ path, message: 'Invalid subnet mask.' });
      return result;
    },
  ),
});
